/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Toolcardchanged2Inputs */

const en_toolcardchanged2 = /** @type {(inputs: Toolcardchanged2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`changed ${i?.fields}`)
};

const pt_toolcardchanged2 = /** @type {(inputs: Toolcardchanged2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`alterou ${i?.fields}`)
};

/**
* | output |
* | --- |
* | "changed {fields}" |
*
* @param {Toolcardchanged2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardchanged2 = /** @type {((inputs: Toolcardchanged2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardchanged2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardchanged2(inputs)
	return pt_toolcardchanged2(inputs)
});
export { toolcardchanged2 as "toolCardChanged" }